export default __webpack_public_path__ + "static/media/fpb20000.ff324c68.png";